import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { Box, Typography } from '@mui/material';
import VacationCalendar from 'widgets/OpeningTimes/Icons/VacationCalendar';

export const EmptyOfflinePeriodsList: React.FC = memo(() => {
  const { formatMessage } = useIntl();

  return (
    <Box>
      <Box display="flex" flexDirection="column" alignItems="center" m="auto">
        <Box mb={2}>
          <VacationCalendar />
        </Box>
        <Box mb={1}>
          <Typography variant="subtitleM">
            {formatMessage({ id: 'offlinePeriods.emptyListTitle' })}
          </Typography>
        </Box>
        <Box>
          <Typography variant="bodyM">
            {formatMessage({ id: 'offlinePeriods.emptyListDescription' })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
});
